var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestartConversation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5699 1.81938C12.9111 1.16141 11.524 0.43361 10.9281 0.137031C10.797 0.0718142 10.6462 0.16787 10.6462 0.314246V2.003C10.6462 2.18018 10.74 2.34402 10.8903 2.43789C11.2149 2.64067 11.7819 3.0122 12.0764 3.30748C14.2132 5.44529 14.2132 8.92109 12.0764 11.0578C9.93971 13.1913 6.46605 13.1913 4.3261 11.0578C2.19152 8.91895 2.19152 5.44529 4.3261 3.30748C4.33146 3.30105 4.34862 3.29033 4.35612 3.28068L5.4534 4.37424C5.51651 4.43714 5.62415 4.39233 5.62399 4.30323L5.61731 0.730058C5.6171 0.619852 5.52778 0.530579 5.41757 0.530432L1.84695 0.525661C1.75779 0.525542 1.71306 0.63333 1.7761 0.696372L2.86588 1.78615C2.85837 1.79901 2.84658 1.81188 2.83693 1.81938C-0.125331 4.78057 -0.125331 9.58474 2.83693 12.5459C5.80348 15.5103 10.6044 15.5103 13.5699 12.5459C16.53 9.58474 16.5332 4.78057 13.5699 1.81938Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartConversation);
export default __webpack_public_path__ + "static/media/restartConversation.6f900943.svg";
export { ForwardRef as ReactComponent };